import {Component, computed, effect, input, signal} from '@angular/core';
import {WineProduct} from '@core/interfaces/generated/graphql';
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {environment} from '@env/environment';
import {captureException} from '@sentry/angular';
import {customImageLoader} from '../../../../../../../../custom-image-loader';

@Component({
  selector: 'app-product-description-text',
  templateUrl: './product-description-text.component.html',
  styleUrls: ['./product-description-text.component.scss'],
  imports: [RouterModule, FontAwesomeModule]
})
export class ProductDescriptionTextComponent {

  description = signal<string>('');

  product = input<WineProduct | undefined>();

  ratingsAmount = input<number | null>(null);

  ratings = computed(() => {
    const product = this.product();
    if (product && product?.meta?.ratings) {
      const ratings = product.meta.ratings.filter((rating) => {
        return !!rating?.reviewSnippet
      });
      const ratingsAmount = this.ratingsAmount();
      if (ratingsAmount) {
        return ratings.slice(0, ratingsAmount);
      }
      return ratings;
    }
    return [];
  })

  constructor() {
    effect(() => {
      const product = this.product();
      if (product && product.body) {
        this.description.set(this.domParser(product.body));
      } else {
        this.description.set('');
      }
    })
  }

  onImageError(src: string) {
    captureException('IMAGE_NOT_FOUND', {
      extra: {
        src
      }
    });
  }

  private domParser(description: any): string {
    if (typeof document === 'undefined') {
      return description;
    }
    let div = document.createElement('div');
    div.innerHTML = description;

    div = this.vimeoParser(div);
    div = this.imageParser(div);

    return new XMLSerializer().serializeToString(div);
  }

  private vimeoParser(div: HTMLDivElement): HTMLDivElement {

    Array.from(div.querySelectorAll('div[data-video-src]')).forEach((value, index) => {

      const child = document.createElement('div');
      child.setAttribute('class', 'vimeo');

      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', `https://player.vimeo.com/video/${value.getAttribute('data-video-src')}`);
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('frameborder', '0');

      child.appendChild(iframe);
      value.replaceWith(child);
    });

    return div;
  }

  private imageParser(div: HTMLDivElement): HTMLDivElement {

    Array.from(div.getElementsByTagName('img')).forEach((value, index) => {

      let path: string | null = value.getAttribute('src');
      if (!path) {
        return;
      }

      if (path.indexOf('/pub/media/') === 0) {
        path = environment.supervin.assets + path;
      }

      const url = customImageLoader({
        width: 500,
        src: path
      })
      value.setAttribute('src', url);
      value.setAttribute('loading', 'lazy');
      value.onerror = ($event) => this.onImageError(url);
    });

    return div;
  }
}

